module.exports = __webpack_public_path__ + "img/playing-cards.943a2914.png";